export default "__VITE_ASSET__C4XX2rgk__"